var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "typing-title" }, [
    _c("h1", { staticClass: "gradient-title" }, [
      _c("span", { domProps: { innerHTML: _vm._s(_vm.animatedTitle) } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }